<template>
	<div class="invoce-bg ticket-box ticket-box-active">
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" @click="back()"></i>
			报销凭证
	    </header>
        <div class="lmy-invoce-menu invoce-write">
            <div class="isshow-inv">
                <p :class="isshowInv?'':'active'" @click="back();isshowInv=false">不需要</p>
                <p :class="isshowInv?'active':''" @click="isshowInv=true">增值税普通发票</p>
            </div>
            <p class="inv-title">入住信息</p>
            <div class="menu-item" v-if="OrderOrBillNo">
                <div class="item-label">订单号</div>
                <div class="item-content align-left">
                    {{OrderOrBillNo}}
                </div>
            </div>
            <div class="menu-item is-link"  @click="controlSelectPage(true,'抬头类型',InvoiceTitleData.value)">
                <div class="item-label">抬头</div>
                <div class="item-content">{{InvoiceTitleData.lable}}</div>
                <div class="item-arrow"><i class="iconfont icon-more"></i></div>
            </div>
            <div class="menu-item">
                <div class="item-label" v-if="InvoiceTitleData.value==0">单位名称</div>
                <div class="item-label" v-else>姓名</div>
                <div class="item-content align-left"><input type="text" placeholder="请输入" v-model="InvoiceName"></div>
            </div>
            <div class="menu-item">
                <div class="item-label">发票金额</div>
                <div class="item-content">{{Accounts}} {{Currency}}</div>
            </div>
            <div class="menu-item is-link" @click="controlSelectPage(true,'发票项目',InvoiceItemData.value)">
                <div class="item-label">发票项目</div>
                <div class="item-content">{{InvoiceItemData.lable}}</div>
                <div class="item-arrow"><i class="iconfont icon-more"></i></div>
            </div>
            <div class="menu-item is-link" v-if="InvoiceTitleData.value==0">
                <div class="item-label">纳税人识别号</div>
                <div class="item-content align-left"><input type="text" placeholder="请输入"  v-model="TaxpayerIdentifyNo"></div>
            </div>
            <div class="menu-item is-link">
                <div class="item-label">邮箱地址</div>
                <div class="item-content align-left"><input type="text" placeholder="用于接收电子发票"  v-model="Email"></div>
            </div>
            <div class="menu-item is-link">
                <div class="item-label">发票备注</div>
                <div class="item-content align-left"><input type="text" placeholder="备注信息"  v-model="Remark"></div>
            </div>
        </div>
             <!-- 下单时 进入 -->
        <div class="lmy-select-btn-box" v-if="payPricy">
            <div class="select-btn" @click="ok()">确定</div>
        </div>
        <!-- 订单列表 进入 -->
        <div class="lmy-select-btn-box" v-else>
            <div class="select-btn" @click="myOrderok()">确定</div>
        </div>
       
        <!-- <div class="book-comfirming" v-if="isshowDialog">
		    <div class='f-modal' >
	            <div class='f-modal-head'>请选择</div>
	            <ul>
                    <li v-for="item in infoList" :key="item.value" @click="selectLi(item.value)">
                        <span>{{item.lable}}</span>
                        <i class="iconfont icon-xuanzhong selectColor" v-if="dataList[dialogType] == item.value"></i>
                        <i class="iconfont icon-notSelect" v-else></i>
                    </li>
                    
                </ul>
	        </div>
	    </div> -->
        <transition  name="slide">
            <selectPage v-if="selectPageType.show" :title="selectPageType.type" :active="selectPageType.active" @getSelectData="getSelectData" @showPage="controlSelectPage"></selectPage>
        </transition>
	</div>

</template>
<script>
    import selectPage from './../../common/cmpnt/selectPage.vue'//选择项页面
	export default{
        name:'user',
        props:['payPricy','Currency'],
        components:{
            selectPage
        },
		data(){
            return {
                InvoiceTitleData:{value:'0',lable:'单位'},//抬头
                InvoiceItemData:{value:'0',lable:'代订房费'},//发票项目
                OrderOrBillNo:'',//订单号
                InvoiceName:'',//名称
                Accounts:this.payPricy ||'无',//金额
                TaxpayerIdentifyNo:'',//纳税人识别号
                Email:'',
                Remark:'',
                isshowInv:true,//是否需要开发票
                selectPageType:{'show':false,'type':'抬头类型','active':''}, 
                dataList:{
                    OrderOrBillNo:'',//订单号
                    InvoiceTitle:'0',//抬头
                    InvoiceName:'',//名称
                    Accounts:this.payPricy ||'无',//金额
                    InvoiceItem:'0',//发票项目
                    InvoiceKind:'0',//发票种类
                    TaxpayerIdentifyNo:'',//纳税人识别号
                    Email:'',
                    Remark:'',
                },
                
            }
        },
        
        watch: {
            payPricy(val){
                this.Accounts = val
                this.dataList.Accounts = val
            }
        },

        created(){
            // this.infoList = this.InvoiceItemList
            // this.getLable(this.InvoiceItemList,'InvoiceItem','InvoiceItemLable')
            // this.getLable(this.InvoiceKindList,'InvoiceKind','InvoiceKindLable')
            // this.getLable(this.InvoiceTitleList,'InvoiceTitle','InvoiceTitleLable')
        },
        methods:{
            // 显示-隐藏 选项页
            controlSelectPage(bool,type,active){
                this.selectPageType.show = bool
                if(type){
                    this.selectPageType.type = type
                    this.selectPageType.active=active
                }
            },
            // 获得选项信息
            getSelectData(item,type){
                if(type=='抬头类型'){
                    this.InvoiceTitleData = item
                }
                else if(type=='发票项目'){
                    this.InvoiceItemData = item
                }
            },
            ok(){
                if(!this.isshowInv){
                    this.back()
                }else{
                    let data= {
                        OrderOrBillNo:this.OrderOrBillNo,
                        InvoiceTitle:this.InvoiceTitleData.value,
                        InvoiceName:this.InvoiceName,
                        Accounts:this.Accounts,
                        InvoiceItem:this.InvoiceItemData.value,
                        InvoiceKind:'0',//发票种类
                        TaxpayerIdentifyNo:this.InvoiceTitleData.value=='0'?this.TaxpayerIdentifyNo:'',
                        Email:this.Email,
                        Remark:this.Remark,
                    }
                    console.log(data)
                    if(this.verify()){
                        this.$emit("modifyInvoice",true,data)
                    }
                }
                
            },
            // 订单列表--开票
            myOrderok(){
                if(!this.isshowInv){
                    this.back()
                }else{
                    if(this.verify()){
                        let data= {
                            OrderOrBillNo:this.OrderOrBillNo,
                            InvoiceTitle:this.InvoiceTitleData.value,
                            InvoiceName:this.InvoiceName,
                            Accounts:this.Accounts,
                            InvoiceItem:this.InvoiceItemData.value,
                            InvoiceKind:'0',//发票种类
                            TaxpayerIdentifyNo:this.TaxpayerIdentifyNo,
                            Email:this.Email,
                            Remark:this.Remark,
                        }
                        var param = data
                        this.postRequest({
                            url: this.Api.InvoiceSave,
                            params: param
                        }).then(res => {
                            if (res && res.IsSuccess) {
                                this.back()
                                this.$emit("changeFilter")
                                this.$alert('已开票')

                            }else{
                                this.error({title: '提示', content: res.Msg || '开票失败'});

                            }
                        });
                    }
                }
            },
            verify(){
                if(!this.InvoiceTitleData.value){
                    this.$alert('请输入发票抬头！')
                    return false;
                }
                else if(!this.InvoiceName && this.InvoiceTitleData.value=='0'){
                    this.$alert('请填写公司名称！')
                    return false;
                }
                else if(!this.InvoiceName && this.InvoiceTitleData.value=='1'){
                    this.$alert('请填写姓名！')
                    return false;
                }
                else if(!this.InvoiceItemData.value){
                    this.$alert('请选择发票项目！')
                    return false;
                }
                else if(!this.TaxpayerIdentifyNo && this.InvoiceTitleData.value=='0'){
                    this.$alert('请输入纳税人识别号！')
                    return false;
                }
                else if(!this.Email){
                    this.$alert('请输入电子邮箱！')
                    return false;
                }
                else if(!this.checkEmail(this.Email)){
                    this.$alert('请输入正确的邮箱地址！')
                    return false;
                }
                else{
                    return true;
                }
            },
            back(){
                this.$emit("offInvoice")
            },
        }	
	}
</script>



// WEBPACK FOOTER //
// src/components/book/reserve/invoice.vue